export default {
  styleOverrides: {
    paperAnchorDockedLeft: {
      boxShadow: "unset",
      borderRight: "unset",
    },
  },
};
